<template>
    <div>
        <el-form :model="devcRelatedPart" ref="devcPart">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">名称</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="name" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input type="text" v-model="devcRelatedPart.name" placeholder="请输入名称"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <!--<div class="form-group center">-->
                    <!--<div class="form-label">-->
                        <!--<label class="required">可维修</label>-->
                    <!--</div>-->
                    <!--<div class="form-value width-2x">-->
                        <!--<el-form-item prop="repairable">-->
                            <!--<el-radio-group v-model="devcRelatedPart.repairable">-->
                                <!--<el-radio :label="true">是</el-radio>-->
                                <!--<el-radio :label="false">否</el-radio>-->
                            <!--</el-radio-group>-->
                        <!--</el-form-item>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="form-group center">
                    <div class="form-label">
                        <label>描述</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="desc">
                            <el-input type="textarea" :rows="4" v-model="devcRelatedPart.memo" placeholder="请输入描述"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    export default {
        name: 'swb-devc-related-part-save',
        desc: '设备部件 - 保存',
        data: function () {
            return {
                // 部件
                devcRelatedPart: {
                    repairable: true
                }
            }
        },
        created: function () {

        },
        methods: {
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            //
            getDlgResult(){
                let devcRelatedPart = Utils.merge({}, this.devcRelatedPart);
                let result = {};
                this.$refs['devcPart'].validate(function (valid) {
                    if(valid) {
                        result.data = devcRelatedPart;
                        result.type = 'info';
                    } else {
                        let msg = '';
                        if(Utils.isNoB(devcRelatedPart.name)) {
                            msg = "请输入名称";
                        }
                        if(!Utils.isNoB(msg)) {
                            msg += "！";
                        }
                        //
                        result.type = 'warn';
                        result.message = msg;
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devc/DevcRelatedPartSave.vue